import PropTypes from 'prop-types';

import styles from './Switch.module.scss';
import { CustomContainer } from '../DependencyHelper';

const Switch = ({
	switchValues = ['Monthly', 'Once-off'],
	handleFirst,
	handleSecond,
	btnfColor,
	btnSColor,
	variant,
    className
}) => {
	const generateVariant = () => {
		switch(variant) {
case "product-carousel":
	return variant ? `${styles["regular-switch--" + variant]}` : "";
	default:
		return variant ? `${styles["regular-switch--" + variant]}` : "";
		}
	}
	return (
		<CustomContainer className = {`${styles["regular-switch"]} ${generateVariant()} ${className ? styles[className] : ''}`}>
			<button id={`main_price_switch_${switchValues[0]}`}
				className={`${styles['first-btn']} ${
					btnfColor ? styles['btn-clicked'] : styles['btn-not-clicked']
				} `}
				onClick={handleFirst}
			>
				{switchValues[0]}
			</button>
			<button  id={`main_price_switch_${switchValues[1]}`}
				className={`${styles['second-btn']} ${
					btnSColor ? styles['btn-clicked'] : styles['btn-not-clicked']
				}`}
				onClick={handleSecond}
			>
				{switchValues[1]}
			</button>
		</CustomContainer>
	);
};

Switch.propTypes = {
	switchValues: PropTypes.array,
	type: PropTypes.string,
	selectedValue: PropTypes.string,
	handleFirst: PropTypes.func,
	handleSecond: PropTypes.func,
	btnfColor: PropTypes.bool,
	btnSColor: PropTypes.bool,
};

export default Switch;
